import React from 'react';
import logo from "../../../assets/logo.png";

const Logo = () => {
  return (
    <div className="uk-text-center uk-margin logo">
      <img src={logo} alt="Logo"/>
    </div>
  );
};

export default Logo;
